import { z } from 'zod';
import { SafeStringSchema } from '../types/CommonSchemas';

export const FirmwareSchema = z.object({
    id: SafeStringSchema,
    version: z.int(),
    deviceVersion: z.int(),
    timeCreate: z.iso.datetime(),
    isRelease: z.boolean(),
    length: z.int(),
    url: SafeStringSchema
});

export type FirmwareData = z.infer<typeof FirmwareSchema>;

export const FirmwareListSchema = z.array(FirmwareSchema);

export type FirmwareDataList = z.infer<typeof FirmwareListSchema>;

export interface FirmwaresFirmwareLoadRequestData {
    formFile?: File;
    fileName?: string;
    version?: string;
    deviceVersion?: string;
}

export interface FirmwaresSetReleaseRequestData {
    isRelease: boolean;
    id: string;
}

export interface FirmwaresDeleteRequestData {
    id: string;
}

export interface FirmwaresAddFirmwareRequestData {
    firmwareUrl: string;
    firmwareVersion: string;
    deviceVersion: string;
}
